import { takeEvery, put, select } from 'redux-saga/effects'
import { isEmpty } from 'ramda'
import {
  CREATE_SYSTEM_NOTIFICATION,
  handleNotificationPanelState,
} from 'actions/application'
import { getHasPersistentNotifictions } from 'selectors/application'
import { getPathname } from 'selectors/router'
import { getEnabledAlertsByZone } from 'selectors/user'

export function* watchPersistentNotifications() {
  yield takeEvery(CREATE_SYSTEM_NOTIFICATION, handleNotificationsPanel)
}

function* handleNotificationsPanel(action) {
  const { persistent } = action
  const hasPersistentNotifications = yield select(getHasPersistentNotifictions)
  const pathname = yield select(getPathname)
  const enabledZoneAlerts = yield select((state) =>
    getEnabledAlertsByZone(state, { pathname })
  )
  const hasAlertsOrNotifications =
    hasPersistentNotifications || !isEmpty(enabledZoneAlerts)
  if (persistent && hasAlertsOrNotifications) {
    yield put(handleNotificationPanelState(true))
  }
}
